module.exports = __webpack_public_path__ + "static/screenshot2-851e2485b51e2feb24e36fcd4578638a.png";